module.exports = __webpack_public_path__ + "img/joinlefttwo.a4a344b8.png";